

//these service simply register with that modeule.
import breedClusterService from './breedcluster.service';
import translationService from './translation/translation.service';
import breedListService from './breedlist.service';
import disodersService from './disorderdata.service';
import entryIdService from './entryid/entryid.service';
import entryService from './entry.service';
import imageService from './image.service';
import navigationService from './navigation.service';
import utilityService from './utility.service';
import weightlistService from './weightlist.service';
import fileService from './file.service';
import chartService from './chart.service';


let serviceModules = [
  breedClusterService
  ,breedListService
  ,disodersService
  ,entryIdService
  ,entryService
  ,imageService
  ,navigationService
  ,utilityService
  ,translationService
  ,weightlistService
  ,fileService
  ,chartService
]


export default angular.module('mars.vet.dnareports.services', serviceModules).name;



// WEBPACK FOOTER //
// ./client/apps/dnareport/services/index.js